import { FunctionComponent, useContext } from 'react'

import { CommentingPromptProps } from './types'
import GenericContext from '@contexts/commenting/genericContext'
import translate from '@i18n'
import useUser from '@hooks/useUser'
import AnswerIndicator from './AnswerIndicator'
import styled from 'styled-components'

const PromptContentButton = styled.button`
  display: block;
  width: 100%;
  padding: 1.25rem;
  box-sizing: border-box;
  background-color: ${({ theme }) => theme.colors.grey.grey_20};
  color: ${({ theme }) => theme.colors.grey.grey_70};
  font-family: ${({ theme }) => theme.fonts.sourceSansPro};
  font-size: 16px;
  font-style: italic;
  text-align: left;
  text-decoration: none;
  line-height: 1.22;
  -moz-appearance: none;
  -webkit-appearance: none;
  border: 0;
  cursor: pointer;
`

const Indicator = styled.div`
  border-left: 1px solid ${({ theme }) => theme.colors.grey.grey_70};
  box-sizing: border-box;
  padding-left: 17px;
`

const CommentingPrompt: FunctionComponent<CommentingPromptProps> = ({
  onClick,
  type,
}) => {
  const userData = useUser()

  const { requireFullLogin } = useContext(GenericContext)

  return (
    <>
      {type === 'answer' && <AnswerIndicator />}

      <PromptContentButton
        type="button"
        onClick={requireFullLogin(() => onClick())}>
        <Indicator>
          {!!userData
            ? userData.email_only
              ? type === 'comment'
                ? translate('commenting.commentPlaceholderEmailOnly')
                : translate('commenting.answerPlaceholderEmailOnly')
              : type === 'comment'
              ? translate('commenting.commentPlaceholder')
              : translate('commenting.answerPlaceholder')
            : type === 'comment'
            ? translate('commenting.commentPlaceholderNotLoggedIn')
            : translate('commenting.answerPlaceholderNotLoggedIn')}
        </Indicator>
      </PromptContentButton>
    </>
  )
}

export default CommentingPrompt
